var Marionette = require('backbone.marionette');

var CommonUtils = require('../../utils/common-utils.js');


var MergePersonPermissionsView = Marionette.View.extend({
    template: require('../../templates/persons/merge-person-permissions-view.html'),

    regions: {
    },

    ui: {
        merge: '.merge',
        remove: '.remove'
    },

    events: {
        'click @ui.merge': 'onRowMerge',
        'click @ui.remove': 'onRowRemove'
    },

    templateContext: function () {
        var that = this;
        var mode = that.getOption('mode');
        return {
            mode: mode,
            personId: that.getOption('personId'),
            personName: that.getOption('personName'),
            permissions: mode == 'from' ? that.getOption('mergeFromPersonPermissionsModel').get('perms') : that.getOption('mergeToPersonPermissionsModel').get('perms'),
            isMergedPermission: that.isMergedPermission,
            isDeprecated: function(permission) {
                return that.getOption('isBeingMerged') ? (that.getOption('isBeingMerged')(permission) ? 'deprecated-header' : '') : ''
            },
            isHidden: function(permission) {
                return that.getOption('isBeingMerged') ? (that.getOption('isBeingMerged')(permission) ? 'hidden' : '') : ''
            },
            formatPerson: that.utils.formatPerson
        }
    },

    initialize: function (options) {
        _.bindAll(this, 'onRowMerge', 'onRowRemove', 'triggerUp', 'isMergedPermission');
        this.utils = new CommonUtils();
    },

    onRender: function () {
    },

    onRowMerge: function(event) {
        this.triggerUp('merge:person:permissions:row', event, this.getOption('mergeFromPersonPermissionsModel').get('perms'));
    },

    onRowRemove: function(event) {
        this.triggerUp('remove:person:permissions:row', event, this.getOption('mergeToPersonPermissionsModel').get('perms'));
    },

    triggerUp: function(action, event, permissions) {
        var id = event.target.id;
        var index = event.target.parentElement.id;
        var permission = _.findWhere(permissions, {id: id});
        this.triggerMethod(action, {
            permission: permission,
            insertedIndex: index
        });

    },

    isMergedPermission: function(p) {
        var that = this;
        if (that.getOption('mergedPermissionsCount')) {
            return that.getOption('mergedPermissionsCount')(that.getOption('mergeToPersonPermissionsModelOriginal').get('perms'), p).length == 0;
        } else return false;
    }
});

module.exports = MergePersonPermissionsView;


//////////////////
// WEBPACK FOOTER
// ./app/views/persons/merge-person-permissions-view.js
// module id = 496
// module chunks = 0